import type { ProjectSemaphore } from '@bp/utils';

interface ProjectSemaphoreProps {
    value: ProjectSemaphore;
}

export function ProjectSemaphoreChip({ value }: ProjectSemaphoreProps) {
    let iconClass = '';
    let colorClass = '';

    switch (value?.value) {
        case 'GREEN':
            iconClass = 'bi-check-circle-fill';
            colorClass = 'text-success';
            break;
        case 'YELLOW':
            iconClass = 'bi-exclamation-triangle-fill';
            colorClass = 'text-warning';
            break;
        case 'RED':
            iconClass = 'bi-exclamation-octagon-fill';
            colorClass = 'text-danger';
            break;
        case 'BLACK':
            iconClass = 'bi-exclamation-octagon-fill';
            colorClass = 'text-dark';
            break;
        default:
            return null;
    }

    return <i className={`fs-4 bi me-2 ${colorClass} ${iconClass}`}></i>;
}
